// ABOUTME: SPEC-82 §4.10 — what the Enter screen needs for voice_hint / primer_collapsible: the node under the button, whether the
// ABOUTME: read-first card shows, and how much room it gives up. Owns the one `open` state so App.js adds none.

import React, { useCallback, useMemo, useState } from 'react';
import GateVoiceHint from './GateVoiceHint';
import { hintReserve } from './gateHintTokens';

export const PRIMER_ID = 'tutorial-primer-card';

/**
 * @param {{ ux: Readonly<Record<string, true>>, hasPrimer: boolean }} p `hasPrimer`: the tenant sent tutorial copy
 * @returns {{ afterButton: (React.ReactNode|null), primerVisible: boolean, extraReserve: number, primerId: (string|undefined) }}
 *   Every flag-off value is today's: no node, the card always shown, nothing reserved, no id.
 */
export default function useGateHint({ ux, hasPrimer }) {
  const [open, setOpen] = useState(false); // closed by default under primer_collapsible
  const toggle = useCallback(() => setOpen((o) => !o), []);
  const voiceHint = !!ux.voice_hint;
  const collapsible = !!ux.primer_collapsible && hasPrimer;

  const afterButton = useMemo(() => (voiceHint || collapsible ? (
    <GateVoiceHint
      voiceHint={voiceHint}
      collapsible={collapsible}
      open={open}
      onToggle={toggle}
      controls={collapsible && open ? PRIMER_ID : undefined}
    />
  ) : null), [voiceHint, collapsible, open, toggle]);

  return {
    afterButton,
    primerVisible: collapsible ? open : true,
    extraReserve: hintReserve({ voiceHint, collapsible }),
    primerId: collapsible ? PRIMER_ID : undefined,
  };
}
